import { create } from "zustand"
import { persist } from "zustand/middleware"

export type FleetView = "grid" | "list"

interface FleetViewStore {
  view: FleetView
  setView: (view: FleetView) => void
}

export const useFleetViewStore = create<FleetViewStore>()(
  persist(
    (set) => ({
      view: "list",
      setView: (view) => set({ view }),
    }),
    {
      name: "fleet-view-storage",
    },
  ),
)
